import { render, staticRenderFns } from "./vue-icon-picker.vue?vue&type=template&id=3f134983&scoped=true&"
import script from "./vue-icon-picker.vue?vue&type=script&lang=js&"
export * from "./vue-icon-picker.vue?vue&type=script&lang=js&"
import style0 from "./vue-icon-picker.vue?vue&type=style&index=0&id=3f134983&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f134983",
  null
  
)

export default component.exports